import store from '/store';
import router from '/router/router';


let checkingAuth = false;
export const check = async () => {
    if (checkingAuth) {
        return;
    }
    checkingAuth = true;
    let isAuthenticated = !!store.getters.isAuthenticated;

    if (isAuthenticated) {
        try {
            /*
            const { cpf, senha } = store.state.cliente;            
            const {cliente, relacoes} = await BuscaRelacaoCliente(cpf,senha);
            store.dispatch('setCliente', cliente);
            store.dispatch('setRelacoes', relacoes);
            */
           if (store.state.expiresAt <= Date.now()/1000) {
               await store.dispatch('refresh');
           }
        } catch (err) {
            console.error(err);
            /*
            store.dispatch('setCliente', {});
            store.dispatch('setRelacoes', []);
            */
            store.state.cliente = {};
            store.state.relaceos = [];
            
            router.replace('/login');
        }
    }
    checkingAuth = false;
};

export default check;